<template>
  <div class="text-sm">
    <p class="mt-6">
      <b>2024.11.22</b> - I've been pushing updates just about every day, so here's a list
      of everything that's gone in since the last notes:
    </p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>
        Notable bug fixes
        <ul>
          <li>- Fixed a bug making players unable to sell their starting bags</li>
          <li>
            - Fixed (only some apparently) AI bugs causing infinite loops in Caverns
          </li>
          <li>
            - Fixed a bug allowing players to skip Caverns levels by spam clicking the
            stairs
          </li>
        </ul>
      </li>
      <li>
        Balance
        <ul>
          <li>- Rebalanced Mystic focus to cost less AP</li>
          <li>
            - Nerfed the "of Terror" weapon suffix to proc less & have shorter duration
          </li>
          <li>
            - Increased the stat bonuses of medium & light armor pieces; increased shield
            AC
          </li>
        </ul>
      </li>
      <li>Caverns: increased the minimum breadth of hallways</li>
      <li>
        Restricted areas of the game for beginners, starting out in Caverns and
        progressively unlocking other areas
      </li>
      <li>Added Russian language support</li>
      <li>Aaaand of course fixed many other bugs, too numerous to mention</li>
    </ul>
  </div>
</template>
